export default {
  title: 'Área | Áreas',
  buttons: {
    create: 'Crear área',
    edit: 'Editar área',
    delete: 'Eliminar áreas',
    actions: {
      close: 'Cerrar',
      save: 'Guardar',
      yes: 'Si',
      no: 'No'
    }
  },
  labels: {
    createArea: 'Crear área',
    editArea: 'Editar área',
    deleteArea: '¿Deseas eliminar el área: {type}?',
    areaName: 'Nombre del área'
  },
  tables: {
    title: 'Áreas',
    loadingMessage: 'Cargando áreas...',
    headers: {
      areaName: 'Nombre de área',
      actions: 'Acciones'
    },
    noData: 'No se encontraron áreas',
    footerText: 'filas por página'
  },
  tooltips: {
    createArea: 'Crear área',
    edit: 'Editar área',
    delete: 'Eliminar área'
  },
  placeholders: {
    areaName: 'Nombre del área'
  },
  alerts: {
  },
  validations: {
  },
  tabs: {
  }
}
